import {Pipe, PipeTransform} from '@angular/core';
import {CheckpointResult} from '../classes/checkpoint-result';
import {CheckpointStatusOrbsEnum} from '../classes/checkpoint-status-orbs.enum';

@Pipe({
    name: 'CheckpointResultLevelStatusPipe',
})
export class CheckpointResultLevelStatusPipe implements PipeTransform {

    transform(checkpointResult: CheckpointResult): string {
        if (checkpointResult.finish_date === null) {
            return CheckpointStatusOrbsEnum.inactive;
        }

        if (checkpointResult.error) {
            return CheckpointStatusOrbsEnum.error;
        }

        if (checkpointResult.warning) {
            return CheckpointStatusOrbsEnum.warning;
        }

        return CheckpointStatusOrbsEnum.success;
    }
}
